<template>
    <div class="tree-result-filter card">
      <div class="card-body">
        <div class="row">
          <div class="col-sm-8">
            <h5 class="h5" v-if="dataSelectedCategory && dataSelectedCategory.id > 0">
              {{ $t('maintenance.measure_categories.selected_measure_label') }}:
              <font-awesome-icon icon="toolbox"/>
              {{ dataSelectedCategory.name }}
            </h5>
            <h5 style="margin-bottom:5px;" v-else>
              {{ $t('maintenance.measure_categories.all_measures_label') }}
            </h5>
            <div v-if="dataSelectedCategory && dataSelectedCategory.id > 0">
              <span class="mr-2">
                {{ $t('maintenance.measure_categories.create.scope_label') }}:
              </span>
              <span v-for="(scope, index) in dataSelectedCategory.scope" :key="'m_c_scope_' + index">
                <span v-if="scope == 'activity'" class="mr-1 text-normal">
                  <font-awesome-icon icon="cubes"/>
                  {{ $t('projects.scope.activity') }}
                </span>
                <span v-if="scope == 'system'" class="text-normal ml-2">
                  <font-awesome-icon icon="desktop"/>
                  {{ $t('projects.scope.system') }}
                </span>
                <span v-if="scope == 'third_party'" class="text-normal ml-2">
                  <font-awesome-icon icon="exchange-alt"/>
                  {{ $t('projects.scope.third_party') }}
                </span>
                <span v-if="scope == 'assessment'" class="text-normal ml-2">
                  <font-awesome-icon icon="crosshairs"/>
                  {{ $t('projects.scope.assessment') }}
                </span>
              </span>
            </div>
          </div>

          <div class="col-md-4 text-right" v-if="dataSelectedCategory && dataSelectedCategory.id > 0">
            <span v-if="isGranted([permissions.MEASURE_CATEGORY_EDIT, permissions.MEASURE_CATEGORY_EDIT_OWN], dataSelectedCategory.created_by) && (!getClient.parent || (getClient.parent && dataSelectedCategory.partition))"
                  class="btn btn-edit"
                  qid="edit-mc-modal"
                  @click="showEditMCModal(dataSelectedCategory)"
            >
              <font-awesome-icon icon="pen"/>
            </span>
            <span @click="showViewMCModal()"
                  qid="view-modal"
                  class="btn btn-view"
            >
              <font-awesome-icon icon="eye"/>
            </span>
            <span v-if="isGranted([permissions.MEASURE_CATEGORY_DELETE, permissions.MEASURE_CATEGORY_DELETE_OWN], dataSelectedCategory.created_by) && (!getClient.parent || (getClient.parent && dataSelectedCategory.partition))"
                  class="btn btn-delete"
                  qid="delete-mc-modal"
                  @click="showConfirmDeleteMCModal(dataSelectedCategory)"
            >
              <font-awesome-icon icon="trash-alt"/>
            </span>
          </div>
        </div>
      </div>


      <!-- Delete measure category confirm modal template -->
      <b-modal ref="delete-category" modal-class="task-modal">
        <template #modal-header="{ close }">
          <div class="" style="width: 100%;">
            <span @click="hideConfirmDeleteMCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
              <font-awesome-icon icon="times"/>
            </span>
            <h5 class="mb-1 text-center" qid="update-m-title">
              {{ $t('maintenance.measure_categories.delete.title') }}
            </h5>
          </div>
        </template>

        <b-alert v-if="error.length"
                 show
                 variant="danger"
                 qid="create-p-error"
        >
          {{ error }}
        </b-alert>

        <div class="mb-2 mt-3" style="font-size:18px;">
          <div>
            {{ $t('maintenance.measure_categories.delete.description') }}
            <span class="text-bold">
              {{ itemToDelete.name }}
            </span>
          </div>
          <div class="mt-2">
            {{ $t('maintenance.measure_categories.delete.are_you_sure') }}
          </div>
        </div>

        <template #modal-footer="{ close }">
          <div class="" style="width: 100%;">
            <div class="alert alert-menu-color color-secondary mb-0" role="alert">
              <div class="row">
                <div class="col-sm-6">

                </div>
                <div class="col-sm-6">
                  <div class="text-right">
                    <b-button class="mt-3"
                              variant="secondary"
                              @click="hideConfirmDeleteMCModal"
                              qid="delete-mc-cancel-button"
                    >
                      {{ $t('maintenance.measure_categories.delete.cancel') }}
                    </b-button>
                    <b-button @click="confirmDeleteMC(itemToDelete)"
                              class="mt-3 ml-3"
                              variant="danger"
                              qid="delete-mc-submit-button"
                              v-if="isGranted([permissions.MEASURE_CATEGORY_DELETE, permissions.MEASURE_CATEGORY_DELETE_OWN], itemToDelete.created_by) && (!getClient.parent || (getClient.parent && itemToDelete.partition))"
                    >
                      {{ $t('maintenance.measure_categories.delete.submit') }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-modal>



      <!-- Edit measure category modal template -->
      <b-modal ref="edit-category" @hide="hideEditMCModal" modal-class="task-modal">
        <template #modal-header="{ close }">
          <div class="" style="width: 100%;">
            <span @click="hideEditMCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
              <font-awesome-icon icon="times"/>
            </span>
            <h5 class="mb-1 text-center" qid="update-tp-title">
              {{ $t('maintenance.measure_categories.update.title') }}
            </h5>
          </div>
        </template>

        <b-alert v-if="error.length"
                 show
                 variant="danger"
                 qid="edit-mc-error"
        >
          {{ error }}
        </b-alert>

        <b-form @submit="editMCFormSubmit" qid="edit-mc-form">
          <div class="form-container">
            <b-form-group>
              <label qid="edit-mc-name-label">
                {{ $t('maintenance.measure_categories.create.name_label') }}
              </label>
              <span class="text-red">*</span>
              <b-form-input
                qid="edit-mc-form-name"
                type="text"
                v-model="MCForm.name"
                :maxLength="255"
                required
                :placeholder="$t('maintenance.measures.create.name_placeholder')"
              ></b-form-input>
            </b-form-group>
            <b-form-group>
              <label qid="create-p-description-label">
                {{ $t('maintenance.measures.create.description_label') }}
              </label>
              <b-form-textarea
                qid="create-p-form-description"
                v-model="MCForm.description"
                rows="6"
                max-rows="6"
                :placeholder="$t('maintenance.measures.create.description_placeholder')"
              ></b-form-textarea>
            </b-form-group>
            <b-form-group>
              <label qid="edit-mc-implementation-status-label">
                {{ $t('maintenance.measure_categories.create.scope_label') }}
              </label>
              <span class="text-red">*</span>
              <multiselect
                  v-model="selectedScopes"
                  :options="scopes"
                  :multiple="true"
                  track-by="value"
                  :taggable="true"
                  :placeholder="$t('maintenance.measure_categories.create.scope_placeholder')"
                  label="name"
                  :select-label="$t('system.dropdown_select_label')"
                  :selected-label="$t('system.dropdown_selected_label')"
                  :deselect-label="$t('system.dropdown_deselect_label')"
                  qid="edit-mc-form-implementation-status"
              ></multiselect>
            </b-form-group>
          </div>
        </b-form>

        <template #modal-footer="{ close }">
          <div class="" style="width: 100%;">
            <div class="alert alert-menu-color color-secondary mb-0" role="alert">
              <div class="row">
                <div class="col-sm-6">

                </div>
                <div class="col-sm-6">
                  <div class="text-right">
                    <b-button class=""
                              variant="secondary"
                              @click="hideEditMCModal"
                              qid="edit-mc-cancel-button"
                    >
                      {{ $t('maintenance.measures.create.cancel') }}
                    </b-button>
                    <b-button type="submit"
                              class="ml-3"
                              variant="success"
                              @click="editMCFormSubmit"
                              :disabled="buttonDisabled"
                              qid="edit-mc-submit-button"
                    >
                      <span v-if="buttonDisabled" class="mr-1">
                        <font-awesome-icon icon="spinner" size="sm" class="fa-spin"/>
                      </span>
                      {{ $t('maintenance.measures.create.submit') }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-modal>


      <!-- View measure category -->
      <b-modal ref="view-category" modal-class="task-modal" @hide="hideViewMCModal">
        <template #modal-header="{ close }">
          <div class="" style="width: 100%;">
            <span @click="hideViewMCModal" class="btn btn-secondary cursor-pointer float-right ml-2 mr-0">
              <font-awesome-icon icon="times"/>
            </span>
            <h5 class="mb-1 text-center" qid="view-mc-title">
              {{ $t('maintenance.measure_categories.view.title') }}
            </h5>
          </div>
        </template>

        <b-alert v-if="error.length"
                 show
                 variant="danger"
                 qid="create-p-error"
        >
          {{ error }}
        </b-alert>

        <label class="mt-3">
          {{ $t('maintenance.measure_categories.create.name_label') }}
        </label>
        <br>
        <span v-if="dataSelectedCategory.name" qid="view-mc-name">
          {{ dataSelectedCategory.name }}
        </span>
        <br>

        <label class="mt-3" v-if="dataSelectedCategory && dataSelectedCategory.scope">
          {{ $t('maintenance.measure_categories.create.scope_label') }}
        </label>
        <br>
        <span v-if="dataSelectedCategory && dataSelectedCategory.scope" qid="view-mc-scope">
          <span>
            <span v-for="(scope, index) in dataSelectedCategory.scope" :key="'view_mc_scope_' + index">
              <span v-if="scope == 'activity'" class="mr-1 text-normal">
                <font-awesome-icon icon="cubes"/>
                  {{ $t('projects.scope.activity') }}
              </span>

              <span v-if="scope == 'system'" class="text-normal ml-2">
                <font-awesome-icon icon="desktop"/>
                  {{ $t('projects.scope.system') }}
              </span>

              <span v-if="scope == 'third_party'" class="text-normal ml-2">
                <font-awesome-icon icon="exchange-alt"/>
                  {{ $t('projects.scope.third_party') }}
              </span>
            </span>
          </span>
        </span>

        <template #modal-footer="{ close }">
          <div class="" style="width: 100%;">
            <div class="alert alert-menu-color color-secondary mb-0" role="alert">
              <div class="row">
                <div class="col-sm-6">

                </div>
                <div class="col-sm-6">
                  <div class="text-right">
                    <b-button class=""
                              variant="secondary"
                              @click="hideViewMCModal"
                              qid="view-mc-cancel-button"
                    >
                      {{ $t('processes.policies.view.close') }}
                    </b-button>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </template>
      </b-modal>
    </div>
</template>

<script>
  import piincHttp from '@/util/configureAxios.js'

  export default {
    name: 'MeasureTopBar',
    data: function() {
      return {
        // loading: true,
        MCForm: {
          name: '',
          description: '',
          scope: []
        },
        error: '',
        selectedScopes: [],
        scopes: [
          { name: this.$t('projects.scope.activity'), value: 'activity' },
          { name: this.$t('projects.scope.system'), value: 'system' },
          { name: this.$t('projects.scope.third_party'), value: 'third_party' },
          { name: this.$t('projects.scope.assessment'), value: 'assessment' },
        ],
        buttonDisabled: false,
        itemToDelete: {},
        // copy of selectedCategory prop
        dataSelectedCategory: {}
      }
    },
    props: {
      selectedCategory: {},
    },
    watch: {
      selectedCategory: function (newValue, oldValue) {
        // Watching the prop and setting it's copy object which is used in this component
        if (newValue) {
          this.dataSelectedCategory = newValue
        } else {
          this.dataSelectedCategory = {}
        }
      },
    },
    computed: {
      getClient() {
        return this.$store.state.client
      },
    },
    methods: {
      // Measure category methods
      showViewMCModal() {
        this.$refs['view-category'].show()
      },
      hideViewMCModal() {
        this.$refs['view-category'].hide()
      },
      // Edit MC
      showEditMCModal(object) {
        let self = this;
        self.selectedScopes = [];
        this.error = '';
        if (object.scope && object.scope.length) {
          _.forEach(object.scope, function (value, key) {
            _.find(self.scopes, function(item) {
              if (item.value === value) {
                self.selectedScopes.push(item)
              }
            });
          })
        }

        this.MCForm.slug = object.slug;
        this.MCForm.name = object.name;
        this.MCForm.description = object.description;
        this.$refs['edit-category'].show()
      },
      hideEditMCModal() {
        this.error = ''
        this.openCategory = {};
        this.$refs['edit-category'].hide()
      },
      editMCFormSubmit(evt) {
        this.buttonDisabled = true;
        // Keep the reference in a variable
        // to use it inside function called when promise returned
        let self = this;
        evt.preventDefault();
        let scopes = []

        // Append list of types
        if (this.selectedScopes && this.selectedScopes.length) {
          for (var i = 0; i < this.selectedScopes.length; i++) {
            scopes.push(this.selectedScopes[i].value)
          }
        }

        this.MCForm.client = this.getClient.slug;
        this.MCForm.scope = scopes;

        if (this.MCForm.scope.length && this.MCForm.name && this.MCForm.name.length) {
          piincHttp.put('measure-categories/' + this.MCForm.slug, this.MCForm).then(function(response) {
            self.hideEditMCModal();
            self.buttonDisabled = false;
            // Store new value from API for updated category
            self.dataSelectedCategory = response.data
            // Emit event together with new value
            self.$emit('forceSideFilterRenderComponent', self.dataSelectedCategory)
            self.$toastr('success', self.$t('maintenance.measure_categories.update.success'))
          }, function(error) {
            if (error.status !== 200) {
              self.buttonDisabled = false;
              self.error = error.data.message;
            }
          })
        } else {
          this.buttonDisabled = false;
          this.error = ''
          if (this.MCForm.name == '') {
            this.error +=  ' ' + this.$t('maintenance.incidents.incident_categories.create.name_error')
          }
          if (this.selectedScopes && !this.selectedScopes.length) {
            this.error +=  ' ' + this.$t('system.scope_error_message')
          }
        }
      },
      // Delete MC
      showConfirmDeleteMCModal(object) {
        this.error = ''
        this.itemToDelete = object
        this.$refs['delete-category'].show()
      },
      hideConfirmDeleteMCModal() {
        this.error = ''
        this.itemToDelete = {}
        this.$refs['delete-category'].hide()
      },
      confirmDeleteMC(object) {
        let self = this;
        piincHttp.delete('measure-categories/' + object.slug).then(function(response) {
          self.hideConfirmDeleteMCModal();
          self.$emit('forceSideFilterRenderComponent', null)
          // Trigger toastr message after MCModal close
          self.$toastr('success', self.$t('maintenance.measure_categories.delete.success'))
        }, function(error) {
          if (error.status !== 200) {
            self.buttonDisabled = false;
            self.error = error.data.message;
          }
        });
      }
    },
    created () {
      let self = this;
      // Create a copy of prop object to avoid directly mutating a prop (throws error)
      this.dataSelectedCategory = this.selectedCategory
    }
  }
</script>
